import { endOfDay, max as maxDate, startOfDay } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import { DRIVER_APP_FULFILMENT_EARLIEST_DATE } from 'components/reports/Metrics/constants/DriverAppFulfilment'
import { DriverAppFulfilmentInputDtoInput } from 'generated/graphql'
import { resolveSupplierActivationPeriod } from 'helpers/metricsPeriod.helpers'

import { DriverAppFulfilmentFilterValues } from './DriverAppFulfilmentFilterCriteria'

interface QueryInput {
  start: Date | null
  end: Date | null
  hasValidRange: boolean
  isCustom: boolean
  input: DriverAppFulfilmentInputDtoInput
}

export const useDriverAppFulfilmentQueryInput = (): QueryInput => {
  const { control } = useFormContext<DriverAppFulfilmentFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const selectedServiceCodes = useWatch({ control, name: 'selectedServiceCodes' })
  const vehicleType = useWatch({ control, name: 'vehicleType' })

  const isCustom = period === 'custom'

  const hasCompleteCustomRange = isCustom && customStart != null && customEnd != null

  const { start: rawStart, end } = hasCompleteCustomRange
    ? { start: startOfDay(customStart), end: endOfDay(customEnd) }
    : resolveSupplierActivationPeriod(period)

  const start = rawStart ? maxDate([rawStart, DRIVER_APP_FULFILMENT_EARLIEST_DATE]) : null

  const hasValidRange = start != null && end != null && start <= end

  return {
    start,
    end,
    hasValidRange,
    isCustom,
    input: {
      start: start ?? new Date(),
      end: end ?? new Date(),
      xeroCodeIds: selectedServiceCodes?.length
        ? selectedServiceCodes.map((option) => option.value)
        : null,
      vehicleType,
    },
  }
}
